module.exports = __webpack_public_path__ + "static/media/Hospitalmang3-150.2a8c048d.webp";